
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexNhJX92rZOihKK8ixEuqv7K_hTxchdEfIbiqmm_45uY1u0Meta } from "/Users/xnng/code/sre/official/official_website/pages/index.vue?macro=true";
import { default as indexaabqg_455FtkRqv4vBDihSMV1z1Mm1kNH6hIIdZ4wMF4cMeta } from "/Users/xnng/code/sre/official/official_website/pages/case/index.vue?macro=true";
import { default as indexUj6NuaEas4c9jgqsEANx_iUzX8BLdBml_450m5WDH5n_AMeta } from "/Users/xnng/code/sre/official/official_website/pages/news/index.vue?macro=true";
import { default as indexG3VtgTv0_45B3Kql5wjTYmuNO53Jq32ugC0F7U6N0K4XsMeta } from "/Users/xnng/code/sre/official/official_website/pages/about/index.vue?macro=true";
import { default as docP7t__45D1lZfe806wOAQPERlYLmalQxHnkXWv_lXkuuzcMeta } from "/Users/xnng/code/sre/official/official_website/pages/services/doc.vue?macro=true";
import { default as faqfjOf4psls2ITT8CEfw0w34z__6qFAIbOtKzpRa6UojAMeta } from "/Users/xnng/code/sre/official/official_website/pages/services/faq.vue?macro=true";
import { default as indexG_45YA_J7X1A3WC175lBkJwYwLVnPWlWbLRuU7RsmvZnMMeta } from "/Users/xnng/code/sre/official/official_website/pages/contact/index.vue?macro=true";
import { default as _91id_93yw0uK8uu5MUAEBm1j0lM0zFv_A44QU_45_45Et4fQKHlAIgMeta } from "/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue?macro=true";
import { default as _91id_93SIK_45hX6oiNKA5g_45OrMvkOUW0IiQEMtjk9J6A_45PNXuG0Meta } from "/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue?macro=true";
import { default as chargerGJpEKSSYqVuz6OCXFFKMhjskln1WuKodZMqsG3_45CbkoMeta } from "/Users/xnng/code/sre/official/official_website/pages/products/charger.vue?macro=true";
import { default as detailKymsO_HARd_45AkORXD_45QiBgTK6J_452xlrSKZO1EXBM4zwMeta } from "/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue?macro=true";
import { default as _91id_93Z29SxzXuJhJmZNdSMQkt8BtP9suWiKLHgTv_TjAP7HsMeta } from "/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue?macro=true";
import { default as battery_45swap_j48JB3N2i397TNv3Xip5ug8NJO2dxvaFgYYrJLlEbgMeta } from "/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue?macro=true";
import { default as battery_45swapvUqtzw_45W1NaNaw83AdS_pZ3SiBASuUaIP9VTkRksyysMeta } from "/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue?macro=true";
import { default as storage_45cabinetV4CmHFDWNkwv3P0rGRPOM7TUW8a9kM4tUJWAuGww6owMeta } from "/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue?macro=true";
import { default as charging_45stationt2N_2OwuYkyp4izezNbzNYOvlh_45_7Sub6yCLaWPUlqkMeta } from "/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue?macro=true";
import { default as storage_45cabinetraxKqwW6dA_8sCJDsVf3PiwMKPPliMxpcg8cyzBYPYQMeta } from "/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue?macro=true";
import { default as charging_45stationCQJ_45a6wu1ICeFPg_nrFFi1Lp7g3p2BjPoFaprNRldnkMeta } from "/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue?macro=true";
export default [
  {
    name: "index___zh-Hans",
    path: "/zh-Hans",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___zh-Hant",
    path: "/zh-Hant",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___af",
    path: "/af",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___am",
    path: "/am",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___as",
    path: "/as",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___az",
    path: "/az",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ba",
    path: "/ba",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___be",
    path: "/be",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___bho",
    path: "/bho",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___bn",
    path: "/bn",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___bo",
    path: "/bo",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___brx",
    path: "/brx",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___bs",
    path: "/bs",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ca",
    path: "/ca",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___cy",
    path: "/cy",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___doi",
    path: "/doi",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___dsb",
    path: "/dsb",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___dv",
    path: "/dv",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___el",
    path: "/el",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___et",
    path: "/et",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___eu",
    path: "/eu",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___fa",
    path: "/fa",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___fi",
    path: "/fi",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___fil",
    path: "/fil",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___fj",
    path: "/fj",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___fo",
    path: "/fo",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___fr-CA",
    path: "/fr-CA",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ga",
    path: "/ga",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___gl",
    path: "/gl",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___gom",
    path: "/gom",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___gu",
    path: "/gu",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ha",
    path: "/ha",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___he",
    path: "/he",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___hne",
    path: "/hne",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___hr",
    path: "/hr",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___hsb",
    path: "/hsb",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ht",
    path: "/ht",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___hy",
    path: "/hy",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ig",
    path: "/ig",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ikt",
    path: "/ikt",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___is",
    path: "/is",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___iu",
    path: "/iu",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___iu-Latn",
    path: "/iu-Latn",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ka",
    path: "/ka",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___kk",
    path: "/kk",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___km",
    path: "/km",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___kmr",
    path: "/kmr",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___kn",
    path: "/kn",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ks",
    path: "/ks",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ku",
    path: "/ku",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ky",
    path: "/ky",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___lb",
    path: "/lb",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ln",
    path: "/ln",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___lo",
    path: "/lo",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___lt",
    path: "/lt",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___lug",
    path: "/lug",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___lv",
    path: "/lv",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___lzh",
    path: "/lzh",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mai",
    path: "/mai",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mg",
    path: "/mg",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mi",
    path: "/mi",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mk",
    path: "/mk",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ml",
    path: "/ml",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mn-Cyrl",
    path: "/mn-Cyrl",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mn-Mong",
    path: "/mn-Mong",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mni",
    path: "/mni",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mr",
    path: "/mr",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ms",
    path: "/ms",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mt",
    path: "/mt",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___mww",
    path: "/mww",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___my",
    path: "/my",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___nb",
    path: "/nb",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ne",
    path: "/ne",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___nso",
    path: "/nso",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___nya",
    path: "/nya",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___or",
    path: "/or",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___otq",
    path: "/otq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___pa",
    path: "/pa",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___prs",
    path: "/prs",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ps",
    path: "/ps",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___pt-PT",
    path: "/pt-PT",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___run",
    path: "/run",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___rw",
    path: "/rw",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sd",
    path: "/sd",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___si",
    path: "/si",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/sk",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sl",
    path: "/sl",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sm",
    path: "/sm",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sn",
    path: "/sn",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___so",
    path: "/so",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sq",
    path: "/sq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sr-Cyrl",
    path: "/sr-Cyrl",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sr-Latn",
    path: "/sr-Latn",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___st",
    path: "/st",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___sw",
    path: "/sw",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ta",
    path: "/ta",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___te",
    path: "/te",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ti",
    path: "/ti",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___tk",
    path: "/tk",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___tlh-Latn",
    path: "/tlh-Latn",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___tlh-Piqd",
    path: "/tlh-Piqd",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___tn",
    path: "/tn",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___to",
    path: "/to",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___tt",
    path: "/tt",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ty",
    path: "/ty",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ug",
    path: "/ug",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___ur",
    path: "/ur",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___uz",
    path: "/uz",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___xh",
    path: "/xh",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___yo",
    path: "/yo",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___yua",
    path: "/yua",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___yue",
    path: "/yue",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "index___zu",
    path: "/zu",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/index.vue")
  },
  {
    name: "case___zh-Hans",
    path: "/zh-Hans/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___en",
    path: "/en/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___fr",
    path: "/fr/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ko",
    path: "/ko/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___th",
    path: "/th/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___zh-Hant",
    path: "/zh-Hant/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___af",
    path: "/af/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___am",
    path: "/am/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ar",
    path: "/ar/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___as",
    path: "/as/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___az",
    path: "/az/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ba",
    path: "/ba/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___be",
    path: "/be/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___bg",
    path: "/bg/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___bho",
    path: "/bho/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___bn",
    path: "/bn/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___bo",
    path: "/bo/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___brx",
    path: "/brx/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___bs",
    path: "/bs/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ca",
    path: "/ca/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___cs",
    path: "/cs/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___cy",
    path: "/cy/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___da",
    path: "/da/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___de",
    path: "/de/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___doi",
    path: "/doi/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___dsb",
    path: "/dsb/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___dv",
    path: "/dv/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___el",
    path: "/el/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___es",
    path: "/es/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___et",
    path: "/et/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___eu",
    path: "/eu/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___fa",
    path: "/fa/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___fi",
    path: "/fi/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___fil",
    path: "/fil/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___fj",
    path: "/fj/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___fo",
    path: "/fo/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___fr-CA",
    path: "/fr-CA/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ga",
    path: "/ga/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___gl",
    path: "/gl/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___gom",
    path: "/gom/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___gu",
    path: "/gu/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ha",
    path: "/ha/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___he",
    path: "/he/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___hi",
    path: "/hi/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___hne",
    path: "/hne/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___hr",
    path: "/hr/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___hsb",
    path: "/hsb/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ht",
    path: "/ht/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___hu",
    path: "/hu/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___hy",
    path: "/hy/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___id",
    path: "/id/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ig",
    path: "/ig/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ikt",
    path: "/ikt/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___is",
    path: "/is/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___it",
    path: "/it/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___iu",
    path: "/iu/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___iu-Latn",
    path: "/iu-Latn/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ja",
    path: "/ja/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ka",
    path: "/ka/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___kk",
    path: "/kk/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___km",
    path: "/km/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___kmr",
    path: "/kmr/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___kn",
    path: "/kn/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ks",
    path: "/ks/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ku",
    path: "/ku/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ky",
    path: "/ky/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___lb",
    path: "/lb/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ln",
    path: "/ln/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___lo",
    path: "/lo/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___lt",
    path: "/lt/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___lug",
    path: "/lug/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___lv",
    path: "/lv/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___lzh",
    path: "/lzh/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mai",
    path: "/mai/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mg",
    path: "/mg/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mi",
    path: "/mi/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mk",
    path: "/mk/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ml",
    path: "/ml/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mn-Cyrl",
    path: "/mn-Cyrl/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mn-Mong",
    path: "/mn-Mong/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mni",
    path: "/mni/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mr",
    path: "/mr/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ms",
    path: "/ms/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mt",
    path: "/mt/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___mww",
    path: "/mww/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___my",
    path: "/my/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___nb",
    path: "/nb/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ne",
    path: "/ne/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___nl",
    path: "/nl/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___nso",
    path: "/nso/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___nya",
    path: "/nya/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___or",
    path: "/or/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___otq",
    path: "/otq/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___pa",
    path: "/pa/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___pl",
    path: "/pl/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___prs",
    path: "/prs/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ps",
    path: "/ps/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___pt",
    path: "/pt/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___pt-PT",
    path: "/pt-PT/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ro",
    path: "/ro/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ru",
    path: "/ru/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___run",
    path: "/run/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___rw",
    path: "/rw/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sd",
    path: "/sd/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___si",
    path: "/si/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sk",
    path: "/sk/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sl",
    path: "/sl/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sm",
    path: "/sm/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sn",
    path: "/sn/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___so",
    path: "/so/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sq",
    path: "/sq/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sr-Cyrl",
    path: "/sr-Cyrl/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sr-Latn",
    path: "/sr-Latn/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___st",
    path: "/st/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sv",
    path: "/sv/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___sw",
    path: "/sw/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ta",
    path: "/ta/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___te",
    path: "/te/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ti",
    path: "/ti/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___tk",
    path: "/tk/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___tlh-Latn",
    path: "/tlh-Latn/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___tlh-Piqd",
    path: "/tlh-Piqd/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___tn",
    path: "/tn/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___to",
    path: "/to/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___tr",
    path: "/tr/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___tt",
    path: "/tt/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ty",
    path: "/ty/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ug",
    path: "/ug/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___uk",
    path: "/uk/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___ur",
    path: "/ur/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___uz",
    path: "/uz/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___vi",
    path: "/vi/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___xh",
    path: "/xh/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___yo",
    path: "/yo/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___yua",
    path: "/yua/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___yue",
    path: "/yue/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "case___zu",
    path: "/zu/case",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/index.vue")
  },
  {
    name: "news___zh-Hans",
    path: "/zh-Hans/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___fr",
    path: "/fr/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ko",
    path: "/ko/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___th",
    path: "/th/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___zh-Hant",
    path: "/zh-Hant/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___af",
    path: "/af/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___am",
    path: "/am/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ar",
    path: "/ar/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___as",
    path: "/as/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___az",
    path: "/az/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ba",
    path: "/ba/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___be",
    path: "/be/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___bg",
    path: "/bg/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___bho",
    path: "/bho/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___bn",
    path: "/bn/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___bo",
    path: "/bo/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___brx",
    path: "/brx/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___bs",
    path: "/bs/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ca",
    path: "/ca/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___cs",
    path: "/cs/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___cy",
    path: "/cy/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___da",
    path: "/da/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___de",
    path: "/de/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___doi",
    path: "/doi/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___dsb",
    path: "/dsb/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___dv",
    path: "/dv/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___el",
    path: "/el/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___es",
    path: "/es/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___et",
    path: "/et/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___eu",
    path: "/eu/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___fa",
    path: "/fa/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___fi",
    path: "/fi/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___fil",
    path: "/fil/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___fj",
    path: "/fj/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___fo",
    path: "/fo/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___fr-CA",
    path: "/fr-CA/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ga",
    path: "/ga/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___gl",
    path: "/gl/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___gom",
    path: "/gom/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___gu",
    path: "/gu/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ha",
    path: "/ha/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___he",
    path: "/he/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___hi",
    path: "/hi/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___hne",
    path: "/hne/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___hr",
    path: "/hr/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___hsb",
    path: "/hsb/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ht",
    path: "/ht/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___hu",
    path: "/hu/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___hy",
    path: "/hy/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___id",
    path: "/id/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ig",
    path: "/ig/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ikt",
    path: "/ikt/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___is",
    path: "/is/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___it",
    path: "/it/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___iu",
    path: "/iu/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___iu-Latn",
    path: "/iu-Latn/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ja",
    path: "/ja/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ka",
    path: "/ka/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___kk",
    path: "/kk/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___km",
    path: "/km/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___kmr",
    path: "/kmr/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___kn",
    path: "/kn/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ks",
    path: "/ks/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ku",
    path: "/ku/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ky",
    path: "/ky/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___lb",
    path: "/lb/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ln",
    path: "/ln/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___lo",
    path: "/lo/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___lt",
    path: "/lt/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___lug",
    path: "/lug/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___lv",
    path: "/lv/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___lzh",
    path: "/lzh/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mai",
    path: "/mai/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mg",
    path: "/mg/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mi",
    path: "/mi/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mk",
    path: "/mk/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ml",
    path: "/ml/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mn-Cyrl",
    path: "/mn-Cyrl/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mn-Mong",
    path: "/mn-Mong/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mni",
    path: "/mni/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mr",
    path: "/mr/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ms",
    path: "/ms/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mt",
    path: "/mt/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___mww",
    path: "/mww/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___my",
    path: "/my/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___nb",
    path: "/nb/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ne",
    path: "/ne/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___nl",
    path: "/nl/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___nso",
    path: "/nso/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___nya",
    path: "/nya/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___or",
    path: "/or/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___otq",
    path: "/otq/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___pa",
    path: "/pa/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___pl",
    path: "/pl/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___prs",
    path: "/prs/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ps",
    path: "/ps/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___pt",
    path: "/pt/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___pt-PT",
    path: "/pt-PT/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ro",
    path: "/ro/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/ru/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___run",
    path: "/run/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___rw",
    path: "/rw/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sd",
    path: "/sd/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___si",
    path: "/si/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sk",
    path: "/sk/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sl",
    path: "/sl/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sm",
    path: "/sm/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sn",
    path: "/sn/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___so",
    path: "/so/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sq",
    path: "/sq/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sr-Cyrl",
    path: "/sr-Cyrl/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sr-Latn",
    path: "/sr-Latn/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___st",
    path: "/st/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sv",
    path: "/sv/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___sw",
    path: "/sw/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ta",
    path: "/ta/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___te",
    path: "/te/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ti",
    path: "/ti/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___tk",
    path: "/tk/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___tlh-Latn",
    path: "/tlh-Latn/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___tlh-Piqd",
    path: "/tlh-Piqd/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___tn",
    path: "/tn/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___to",
    path: "/to/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___tr",
    path: "/tr/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___tt",
    path: "/tt/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ty",
    path: "/ty/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ug",
    path: "/ug/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___uk",
    path: "/uk/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___ur",
    path: "/ur/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___uz",
    path: "/uz/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___vi",
    path: "/vi/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___xh",
    path: "/xh/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___yo",
    path: "/yo/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___yua",
    path: "/yua/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___yue",
    path: "/yue/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "news___zu",
    path: "/zu/news",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/index.vue")
  },
  {
    name: "about___zh-Hans",
    path: "/zh-Hans/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___fr",
    path: "/fr/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ko",
    path: "/ko/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___th",
    path: "/th/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___zh-Hant",
    path: "/zh-Hant/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___af",
    path: "/af/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___am",
    path: "/am/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ar",
    path: "/ar/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___as",
    path: "/as/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___az",
    path: "/az/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ba",
    path: "/ba/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___be",
    path: "/be/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___bg",
    path: "/bg/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___bho",
    path: "/bho/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___bn",
    path: "/bn/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___bo",
    path: "/bo/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___brx",
    path: "/brx/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___bs",
    path: "/bs/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ca",
    path: "/ca/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___cs",
    path: "/cs/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___cy",
    path: "/cy/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___da",
    path: "/da/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___de",
    path: "/de/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___doi",
    path: "/doi/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___dsb",
    path: "/dsb/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___dv",
    path: "/dv/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___el",
    path: "/el/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___et",
    path: "/et/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___eu",
    path: "/eu/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___fa",
    path: "/fa/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___fi",
    path: "/fi/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___fil",
    path: "/fil/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___fj",
    path: "/fj/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___fo",
    path: "/fo/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___fr-CA",
    path: "/fr-CA/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ga",
    path: "/ga/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___gl",
    path: "/gl/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___gom",
    path: "/gom/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___gu",
    path: "/gu/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ha",
    path: "/ha/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___he",
    path: "/he/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___hi",
    path: "/hi/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___hne",
    path: "/hne/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___hr",
    path: "/hr/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___hsb",
    path: "/hsb/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ht",
    path: "/ht/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___hu",
    path: "/hu/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___hy",
    path: "/hy/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___id",
    path: "/id/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ig",
    path: "/ig/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ikt",
    path: "/ikt/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___is",
    path: "/is/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___it",
    path: "/it/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___iu",
    path: "/iu/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___iu-Latn",
    path: "/iu-Latn/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ja",
    path: "/ja/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ka",
    path: "/ka/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___kk",
    path: "/kk/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___km",
    path: "/km/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___kmr",
    path: "/kmr/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___kn",
    path: "/kn/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ks",
    path: "/ks/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ku",
    path: "/ku/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ky",
    path: "/ky/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___lb",
    path: "/lb/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ln",
    path: "/ln/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___lo",
    path: "/lo/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___lt",
    path: "/lt/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___lug",
    path: "/lug/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___lv",
    path: "/lv/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___lzh",
    path: "/lzh/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mai",
    path: "/mai/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mg",
    path: "/mg/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mi",
    path: "/mi/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mk",
    path: "/mk/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ml",
    path: "/ml/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mn-Cyrl",
    path: "/mn-Cyrl/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mn-Mong",
    path: "/mn-Mong/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mni",
    path: "/mni/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mr",
    path: "/mr/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ms",
    path: "/ms/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mt",
    path: "/mt/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___mww",
    path: "/mww/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___my",
    path: "/my/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___nb",
    path: "/nb/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ne",
    path: "/ne/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___nl",
    path: "/nl/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___nso",
    path: "/nso/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___nya",
    path: "/nya/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___or",
    path: "/or/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___otq",
    path: "/otq/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___pa",
    path: "/pa/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___prs",
    path: "/prs/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ps",
    path: "/ps/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___pt",
    path: "/pt/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___pt-PT",
    path: "/pt-PT/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ro",
    path: "/ro/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ru",
    path: "/ru/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___run",
    path: "/run/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___rw",
    path: "/rw/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sd",
    path: "/sd/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___si",
    path: "/si/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sk",
    path: "/sk/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sl",
    path: "/sl/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sm",
    path: "/sm/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sn",
    path: "/sn/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___so",
    path: "/so/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sq",
    path: "/sq/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sr-Cyrl",
    path: "/sr-Cyrl/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sr-Latn",
    path: "/sr-Latn/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___st",
    path: "/st/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sv",
    path: "/sv/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___sw",
    path: "/sw/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ta",
    path: "/ta/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___te",
    path: "/te/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ti",
    path: "/ti/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___tk",
    path: "/tk/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___tlh-Latn",
    path: "/tlh-Latn/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___tlh-Piqd",
    path: "/tlh-Piqd/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___tn",
    path: "/tn/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___to",
    path: "/to/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___tr",
    path: "/tr/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___tt",
    path: "/tt/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ty",
    path: "/ty/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ug",
    path: "/ug/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___uk",
    path: "/uk/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___ur",
    path: "/ur/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___uz",
    path: "/uz/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___vi",
    path: "/vi/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___xh",
    path: "/xh/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___yo",
    path: "/yo/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___yua",
    path: "/yua/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___yue",
    path: "/yue/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "about___zu",
    path: "/zu/about",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/about/index.vue")
  },
  {
    name: "services-doc___zh-Hans",
    path: "/zh-Hans/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___en",
    path: "/en/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___fr",
    path: "/fr/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ko",
    path: "/ko/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___th",
    path: "/th/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___zh-Hant",
    path: "/zh-Hant/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___af",
    path: "/af/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___am",
    path: "/am/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ar",
    path: "/ar/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___as",
    path: "/as/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___az",
    path: "/az/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ba",
    path: "/ba/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___be",
    path: "/be/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___bg",
    path: "/bg/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___bho",
    path: "/bho/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___bn",
    path: "/bn/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___bo",
    path: "/bo/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___brx",
    path: "/brx/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___bs",
    path: "/bs/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ca",
    path: "/ca/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___cs",
    path: "/cs/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___cy",
    path: "/cy/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___da",
    path: "/da/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___de",
    path: "/de/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___doi",
    path: "/doi/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___dsb",
    path: "/dsb/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___dv",
    path: "/dv/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___el",
    path: "/el/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___es",
    path: "/es/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___et",
    path: "/et/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___eu",
    path: "/eu/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___fa",
    path: "/fa/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___fi",
    path: "/fi/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___fil",
    path: "/fil/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___fj",
    path: "/fj/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___fo",
    path: "/fo/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___fr-CA",
    path: "/fr-CA/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ga",
    path: "/ga/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___gl",
    path: "/gl/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___gom",
    path: "/gom/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___gu",
    path: "/gu/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ha",
    path: "/ha/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___he",
    path: "/he/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___hi",
    path: "/hi/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___hne",
    path: "/hne/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___hr",
    path: "/hr/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___hsb",
    path: "/hsb/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ht",
    path: "/ht/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___hu",
    path: "/hu/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___hy",
    path: "/hy/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___id",
    path: "/id/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ig",
    path: "/ig/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ikt",
    path: "/ikt/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___is",
    path: "/is/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___it",
    path: "/it/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___iu",
    path: "/iu/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___iu-Latn",
    path: "/iu-Latn/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ja",
    path: "/ja/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ka",
    path: "/ka/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___kk",
    path: "/kk/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___km",
    path: "/km/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___kmr",
    path: "/kmr/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___kn",
    path: "/kn/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ks",
    path: "/ks/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ku",
    path: "/ku/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ky",
    path: "/ky/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___lb",
    path: "/lb/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ln",
    path: "/ln/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___lo",
    path: "/lo/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___lt",
    path: "/lt/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___lug",
    path: "/lug/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___lv",
    path: "/lv/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___lzh",
    path: "/lzh/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mai",
    path: "/mai/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mg",
    path: "/mg/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mi",
    path: "/mi/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mk",
    path: "/mk/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ml",
    path: "/ml/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mn-Cyrl",
    path: "/mn-Cyrl/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mn-Mong",
    path: "/mn-Mong/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mni",
    path: "/mni/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mr",
    path: "/mr/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ms",
    path: "/ms/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mt",
    path: "/mt/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___mww",
    path: "/mww/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___my",
    path: "/my/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___nb",
    path: "/nb/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ne",
    path: "/ne/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___nl",
    path: "/nl/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___nso",
    path: "/nso/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___nya",
    path: "/nya/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___or",
    path: "/or/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___otq",
    path: "/otq/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___pa",
    path: "/pa/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___pl",
    path: "/pl/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___prs",
    path: "/prs/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ps",
    path: "/ps/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___pt",
    path: "/pt/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___pt-PT",
    path: "/pt-PT/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ro",
    path: "/ro/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ru",
    path: "/ru/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___run",
    path: "/run/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___rw",
    path: "/rw/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sd",
    path: "/sd/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___si",
    path: "/si/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sk",
    path: "/sk/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sl",
    path: "/sl/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sm",
    path: "/sm/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sn",
    path: "/sn/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___so",
    path: "/so/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sq",
    path: "/sq/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sr-Cyrl",
    path: "/sr-Cyrl/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sr-Latn",
    path: "/sr-Latn/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___st",
    path: "/st/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sv",
    path: "/sv/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___sw",
    path: "/sw/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ta",
    path: "/ta/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___te",
    path: "/te/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ti",
    path: "/ti/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___tk",
    path: "/tk/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___tlh-Latn",
    path: "/tlh-Latn/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___tlh-Piqd",
    path: "/tlh-Piqd/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___tn",
    path: "/tn/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___to",
    path: "/to/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___tr",
    path: "/tr/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___tt",
    path: "/tt/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ty",
    path: "/ty/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ug",
    path: "/ug/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___uk",
    path: "/uk/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___ur",
    path: "/ur/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___uz",
    path: "/uz/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___vi",
    path: "/vi/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___xh",
    path: "/xh/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___yo",
    path: "/yo/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___yua",
    path: "/yua/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___yue",
    path: "/yue/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-doc___zu",
    path: "/zu/services/doc",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/doc.vue")
  },
  {
    name: "services-faq___zh-Hans",
    path: "/zh-Hans/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___en",
    path: "/en/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___fr",
    path: "/fr/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ko",
    path: "/ko/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___th",
    path: "/th/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___zh-Hant",
    path: "/zh-Hant/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___af",
    path: "/af/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___am",
    path: "/am/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ar",
    path: "/ar/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___as",
    path: "/as/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___az",
    path: "/az/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ba",
    path: "/ba/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___be",
    path: "/be/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___bg",
    path: "/bg/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___bho",
    path: "/bho/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___bn",
    path: "/bn/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___bo",
    path: "/bo/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___brx",
    path: "/brx/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___bs",
    path: "/bs/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ca",
    path: "/ca/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___cs",
    path: "/cs/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___cy",
    path: "/cy/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___da",
    path: "/da/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___de",
    path: "/de/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___doi",
    path: "/doi/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___dsb",
    path: "/dsb/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___dv",
    path: "/dv/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___el",
    path: "/el/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___es",
    path: "/es/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___et",
    path: "/et/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___eu",
    path: "/eu/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___fa",
    path: "/fa/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___fi",
    path: "/fi/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___fil",
    path: "/fil/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___fj",
    path: "/fj/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___fo",
    path: "/fo/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___fr-CA",
    path: "/fr-CA/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ga",
    path: "/ga/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___gl",
    path: "/gl/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___gom",
    path: "/gom/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___gu",
    path: "/gu/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ha",
    path: "/ha/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___he",
    path: "/he/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___hi",
    path: "/hi/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___hne",
    path: "/hne/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___hr",
    path: "/hr/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___hsb",
    path: "/hsb/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ht",
    path: "/ht/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___hu",
    path: "/hu/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___hy",
    path: "/hy/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___id",
    path: "/id/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ig",
    path: "/ig/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ikt",
    path: "/ikt/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___is",
    path: "/is/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___it",
    path: "/it/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___iu",
    path: "/iu/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___iu-Latn",
    path: "/iu-Latn/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ja",
    path: "/ja/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ka",
    path: "/ka/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___kk",
    path: "/kk/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___km",
    path: "/km/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___kmr",
    path: "/kmr/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___kn",
    path: "/kn/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ks",
    path: "/ks/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ku",
    path: "/ku/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ky",
    path: "/ky/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___lb",
    path: "/lb/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ln",
    path: "/ln/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___lo",
    path: "/lo/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___lt",
    path: "/lt/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___lug",
    path: "/lug/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___lv",
    path: "/lv/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___lzh",
    path: "/lzh/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mai",
    path: "/mai/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mg",
    path: "/mg/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mi",
    path: "/mi/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mk",
    path: "/mk/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ml",
    path: "/ml/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mn-Cyrl",
    path: "/mn-Cyrl/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mn-Mong",
    path: "/mn-Mong/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mni",
    path: "/mni/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mr",
    path: "/mr/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ms",
    path: "/ms/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mt",
    path: "/mt/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___mww",
    path: "/mww/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___my",
    path: "/my/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___nb",
    path: "/nb/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ne",
    path: "/ne/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___nl",
    path: "/nl/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___nso",
    path: "/nso/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___nya",
    path: "/nya/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___or",
    path: "/or/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___otq",
    path: "/otq/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___pa",
    path: "/pa/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___pl",
    path: "/pl/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___prs",
    path: "/prs/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ps",
    path: "/ps/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___pt",
    path: "/pt/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___pt-PT",
    path: "/pt-PT/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ro",
    path: "/ro/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ru",
    path: "/ru/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___run",
    path: "/run/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___rw",
    path: "/rw/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sd",
    path: "/sd/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___si",
    path: "/si/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sk",
    path: "/sk/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sl",
    path: "/sl/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sm",
    path: "/sm/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sn",
    path: "/sn/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___so",
    path: "/so/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sq",
    path: "/sq/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sr-Cyrl",
    path: "/sr-Cyrl/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sr-Latn",
    path: "/sr-Latn/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___st",
    path: "/st/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sv",
    path: "/sv/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___sw",
    path: "/sw/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ta",
    path: "/ta/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___te",
    path: "/te/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ti",
    path: "/ti/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___tk",
    path: "/tk/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___tlh-Latn",
    path: "/tlh-Latn/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___tlh-Piqd",
    path: "/tlh-Piqd/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___tn",
    path: "/tn/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___to",
    path: "/to/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___tr",
    path: "/tr/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___tt",
    path: "/tt/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ty",
    path: "/ty/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ug",
    path: "/ug/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___uk",
    path: "/uk/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___ur",
    path: "/ur/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___uz",
    path: "/uz/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___vi",
    path: "/vi/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___xh",
    path: "/xh/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___yo",
    path: "/yo/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___yua",
    path: "/yua/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___yue",
    path: "/yue/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "services-faq___zu",
    path: "/zu/services/faq",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/services/faq.vue")
  },
  {
    name: "contact___zh-Hans",
    path: "/zh-Hans/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ko",
    path: "/ko/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___th",
    path: "/th/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___zh-Hant",
    path: "/zh-Hant/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___af",
    path: "/af/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___am",
    path: "/am/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ar",
    path: "/ar/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___as",
    path: "/as/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___az",
    path: "/az/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ba",
    path: "/ba/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___be",
    path: "/be/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___bg",
    path: "/bg/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___bho",
    path: "/bho/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___bn",
    path: "/bn/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___bo",
    path: "/bo/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___brx",
    path: "/brx/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___bs",
    path: "/bs/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ca",
    path: "/ca/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___cs",
    path: "/cs/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___cy",
    path: "/cy/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___da",
    path: "/da/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___de",
    path: "/de/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___doi",
    path: "/doi/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___dsb",
    path: "/dsb/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___dv",
    path: "/dv/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___el",
    path: "/el/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___et",
    path: "/et/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___eu",
    path: "/eu/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___fa",
    path: "/fa/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___fi",
    path: "/fi/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___fil",
    path: "/fil/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___fj",
    path: "/fj/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___fo",
    path: "/fo/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___fr-CA",
    path: "/fr-CA/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ga",
    path: "/ga/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___gl",
    path: "/gl/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___gom",
    path: "/gom/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___gu",
    path: "/gu/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ha",
    path: "/ha/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___he",
    path: "/he/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___hi",
    path: "/hi/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___hne",
    path: "/hne/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___hr",
    path: "/hr/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___hsb",
    path: "/hsb/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ht",
    path: "/ht/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___hu",
    path: "/hu/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___hy",
    path: "/hy/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___id",
    path: "/id/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ig",
    path: "/ig/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ikt",
    path: "/ikt/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___is",
    path: "/is/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___it",
    path: "/it/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___iu",
    path: "/iu/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___iu-Latn",
    path: "/iu-Latn/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ja",
    path: "/ja/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ka",
    path: "/ka/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___kk",
    path: "/kk/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___km",
    path: "/km/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___kmr",
    path: "/kmr/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___kn",
    path: "/kn/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ks",
    path: "/ks/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ku",
    path: "/ku/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ky",
    path: "/ky/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___lb",
    path: "/lb/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ln",
    path: "/ln/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___lo",
    path: "/lo/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___lt",
    path: "/lt/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___lug",
    path: "/lug/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___lv",
    path: "/lv/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___lzh",
    path: "/lzh/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mai",
    path: "/mai/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mg",
    path: "/mg/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mi",
    path: "/mi/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mk",
    path: "/mk/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ml",
    path: "/ml/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mn-Cyrl",
    path: "/mn-Cyrl/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mn-Mong",
    path: "/mn-Mong/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mni",
    path: "/mni/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mr",
    path: "/mr/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ms",
    path: "/ms/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mt",
    path: "/mt/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___mww",
    path: "/mww/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___my",
    path: "/my/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___nb",
    path: "/nb/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ne",
    path: "/ne/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___nl",
    path: "/nl/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___nso",
    path: "/nso/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___nya",
    path: "/nya/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___or",
    path: "/or/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___otq",
    path: "/otq/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___pa",
    path: "/pa/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___pl",
    path: "/pl/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___prs",
    path: "/prs/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ps",
    path: "/ps/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___pt",
    path: "/pt/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___pt-PT",
    path: "/pt-PT/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ro",
    path: "/ro/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ru",
    path: "/ru/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___run",
    path: "/run/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___rw",
    path: "/rw/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sd",
    path: "/sd/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___si",
    path: "/si/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sk",
    path: "/sk/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sl",
    path: "/sl/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sm",
    path: "/sm/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sn",
    path: "/sn/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___so",
    path: "/so/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sq",
    path: "/sq/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sr-Cyrl",
    path: "/sr-Cyrl/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sr-Latn",
    path: "/sr-Latn/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___st",
    path: "/st/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sv",
    path: "/sv/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___sw",
    path: "/sw/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ta",
    path: "/ta/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___te",
    path: "/te/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ti",
    path: "/ti/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___tk",
    path: "/tk/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___tlh-Latn",
    path: "/tlh-Latn/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___tlh-Piqd",
    path: "/tlh-Piqd/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___tn",
    path: "/tn/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___to",
    path: "/to/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___tr",
    path: "/tr/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___tt",
    path: "/tt/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ty",
    path: "/ty/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ug",
    path: "/ug/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___uk",
    path: "/uk/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___ur",
    path: "/ur/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___uz",
    path: "/uz/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___vi",
    path: "/vi/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___xh",
    path: "/xh/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___yo",
    path: "/yo/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___yua",
    path: "/yua/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___yue",
    path: "/yue/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "contact___zu",
    path: "/zu/contact",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/contact/index.vue")
  },
  {
    name: "case-detail-id___zh-Hans",
    path: "/zh-Hans/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___en",
    path: "/en/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___fr",
    path: "/fr/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ko",
    path: "/ko/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___th",
    path: "/th/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___zh-Hant",
    path: "/zh-Hant/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___af",
    path: "/af/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___am",
    path: "/am/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ar",
    path: "/ar/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___as",
    path: "/as/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___az",
    path: "/az/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ba",
    path: "/ba/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___be",
    path: "/be/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___bg",
    path: "/bg/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___bho",
    path: "/bho/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___bn",
    path: "/bn/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___bo",
    path: "/bo/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___brx",
    path: "/brx/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___bs",
    path: "/bs/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ca",
    path: "/ca/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___cs",
    path: "/cs/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___cy",
    path: "/cy/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___da",
    path: "/da/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___de",
    path: "/de/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___doi",
    path: "/doi/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___dsb",
    path: "/dsb/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___dv",
    path: "/dv/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___el",
    path: "/el/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___es",
    path: "/es/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___et",
    path: "/et/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___eu",
    path: "/eu/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___fa",
    path: "/fa/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___fi",
    path: "/fi/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___fil",
    path: "/fil/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___fj",
    path: "/fj/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___fo",
    path: "/fo/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___fr-CA",
    path: "/fr-CA/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ga",
    path: "/ga/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___gl",
    path: "/gl/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___gom",
    path: "/gom/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___gu",
    path: "/gu/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ha",
    path: "/ha/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___he",
    path: "/he/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___hi",
    path: "/hi/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___hne",
    path: "/hne/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___hr",
    path: "/hr/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___hsb",
    path: "/hsb/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ht",
    path: "/ht/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___hu",
    path: "/hu/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___hy",
    path: "/hy/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___id",
    path: "/id/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ig",
    path: "/ig/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ikt",
    path: "/ikt/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___is",
    path: "/is/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___it",
    path: "/it/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___iu",
    path: "/iu/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___iu-Latn",
    path: "/iu-Latn/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ja",
    path: "/ja/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ka",
    path: "/ka/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___kk",
    path: "/kk/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___km",
    path: "/km/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___kmr",
    path: "/kmr/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___kn",
    path: "/kn/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ks",
    path: "/ks/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ku",
    path: "/ku/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ky",
    path: "/ky/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___lb",
    path: "/lb/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ln",
    path: "/ln/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___lo",
    path: "/lo/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___lt",
    path: "/lt/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___lug",
    path: "/lug/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___lv",
    path: "/lv/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___lzh",
    path: "/lzh/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mai",
    path: "/mai/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mg",
    path: "/mg/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mi",
    path: "/mi/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mk",
    path: "/mk/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ml",
    path: "/ml/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mn-Cyrl",
    path: "/mn-Cyrl/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mn-Mong",
    path: "/mn-Mong/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mni",
    path: "/mni/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mr",
    path: "/mr/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ms",
    path: "/ms/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mt",
    path: "/mt/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___mww",
    path: "/mww/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___my",
    path: "/my/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___nb",
    path: "/nb/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ne",
    path: "/ne/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___nl",
    path: "/nl/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___nso",
    path: "/nso/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___nya",
    path: "/nya/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___or",
    path: "/or/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___otq",
    path: "/otq/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___pa",
    path: "/pa/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___pl",
    path: "/pl/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___prs",
    path: "/prs/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ps",
    path: "/ps/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___pt",
    path: "/pt/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___pt-PT",
    path: "/pt-PT/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ro",
    path: "/ro/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ru",
    path: "/ru/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___run",
    path: "/run/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___rw",
    path: "/rw/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sd",
    path: "/sd/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___si",
    path: "/si/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sk",
    path: "/sk/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sl",
    path: "/sl/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sm",
    path: "/sm/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sn",
    path: "/sn/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___so",
    path: "/so/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sq",
    path: "/sq/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sr-Cyrl",
    path: "/sr-Cyrl/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sr-Latn",
    path: "/sr-Latn/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___st",
    path: "/st/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sv",
    path: "/sv/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___sw",
    path: "/sw/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ta",
    path: "/ta/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___te",
    path: "/te/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ti",
    path: "/ti/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___tk",
    path: "/tk/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___tlh-Latn",
    path: "/tlh-Latn/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___tlh-Piqd",
    path: "/tlh-Piqd/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___tn",
    path: "/tn/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___to",
    path: "/to/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___tr",
    path: "/tr/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___tt",
    path: "/tt/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ty",
    path: "/ty/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ug",
    path: "/ug/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___uk",
    path: "/uk/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___ur",
    path: "/ur/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___uz",
    path: "/uz/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___vi",
    path: "/vi/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___xh",
    path: "/xh/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___yo",
    path: "/yo/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___yua",
    path: "/yua/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___yue",
    path: "/yue/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "case-detail-id___zu",
    path: "/zu/case/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/case/detail/[id].vue")
  },
  {
    name: "news-detail-id___zh-Hans",
    path: "/zh-Hans/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___en",
    path: "/en/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___fr",
    path: "/fr/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ko",
    path: "/ko/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___th",
    path: "/th/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___zh-Hant",
    path: "/zh-Hant/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___af",
    path: "/af/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___am",
    path: "/am/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ar",
    path: "/ar/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___as",
    path: "/as/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___az",
    path: "/az/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ba",
    path: "/ba/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___be",
    path: "/be/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___bg",
    path: "/bg/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___bho",
    path: "/bho/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___bn",
    path: "/bn/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___bo",
    path: "/bo/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___brx",
    path: "/brx/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___bs",
    path: "/bs/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ca",
    path: "/ca/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___cs",
    path: "/cs/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___cy",
    path: "/cy/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___da",
    path: "/da/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___de",
    path: "/de/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___doi",
    path: "/doi/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___dsb",
    path: "/dsb/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___dv",
    path: "/dv/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___el",
    path: "/el/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___es",
    path: "/es/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___et",
    path: "/et/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___eu",
    path: "/eu/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___fa",
    path: "/fa/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___fi",
    path: "/fi/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___fil",
    path: "/fil/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___fj",
    path: "/fj/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___fo",
    path: "/fo/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___fr-CA",
    path: "/fr-CA/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ga",
    path: "/ga/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___gl",
    path: "/gl/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___gom",
    path: "/gom/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___gu",
    path: "/gu/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ha",
    path: "/ha/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___he",
    path: "/he/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___hi",
    path: "/hi/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___hne",
    path: "/hne/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___hr",
    path: "/hr/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___hsb",
    path: "/hsb/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ht",
    path: "/ht/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___hu",
    path: "/hu/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___hy",
    path: "/hy/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___id",
    path: "/id/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ig",
    path: "/ig/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ikt",
    path: "/ikt/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___is",
    path: "/is/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___it",
    path: "/it/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___iu",
    path: "/iu/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___iu-Latn",
    path: "/iu-Latn/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ja",
    path: "/ja/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ka",
    path: "/ka/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___kk",
    path: "/kk/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___km",
    path: "/km/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___kmr",
    path: "/kmr/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___kn",
    path: "/kn/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ks",
    path: "/ks/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ku",
    path: "/ku/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ky",
    path: "/ky/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___lb",
    path: "/lb/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ln",
    path: "/ln/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___lo",
    path: "/lo/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___lt",
    path: "/lt/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___lug",
    path: "/lug/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___lv",
    path: "/lv/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___lzh",
    path: "/lzh/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mai",
    path: "/mai/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mg",
    path: "/mg/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mi",
    path: "/mi/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mk",
    path: "/mk/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ml",
    path: "/ml/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mn-Cyrl",
    path: "/mn-Cyrl/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mn-Mong",
    path: "/mn-Mong/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mni",
    path: "/mni/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mr",
    path: "/mr/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ms",
    path: "/ms/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mt",
    path: "/mt/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___mww",
    path: "/mww/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___my",
    path: "/my/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___nb",
    path: "/nb/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ne",
    path: "/ne/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___nl",
    path: "/nl/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___nso",
    path: "/nso/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___nya",
    path: "/nya/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___or",
    path: "/or/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___otq",
    path: "/otq/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___pa",
    path: "/pa/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___pl",
    path: "/pl/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___prs",
    path: "/prs/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ps",
    path: "/ps/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___pt",
    path: "/pt/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___pt-PT",
    path: "/pt-PT/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ro",
    path: "/ro/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ru",
    path: "/ru/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___run",
    path: "/run/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___rw",
    path: "/rw/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sd",
    path: "/sd/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___si",
    path: "/si/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sk",
    path: "/sk/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sl",
    path: "/sl/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sm",
    path: "/sm/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sn",
    path: "/sn/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___so",
    path: "/so/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sq",
    path: "/sq/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sr-Cyrl",
    path: "/sr-Cyrl/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sr-Latn",
    path: "/sr-Latn/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___st",
    path: "/st/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sv",
    path: "/sv/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___sw",
    path: "/sw/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ta",
    path: "/ta/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___te",
    path: "/te/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ti",
    path: "/ti/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___tk",
    path: "/tk/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___tlh-Latn",
    path: "/tlh-Latn/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___tlh-Piqd",
    path: "/tlh-Piqd/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___tn",
    path: "/tn/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___to",
    path: "/to/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___tr",
    path: "/tr/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___tt",
    path: "/tt/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ty",
    path: "/ty/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ug",
    path: "/ug/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___uk",
    path: "/uk/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___ur",
    path: "/ur/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___uz",
    path: "/uz/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___vi",
    path: "/vi/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___xh",
    path: "/xh/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___yo",
    path: "/yo/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___yua",
    path: "/yua/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___yue",
    path: "/yue/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "news-detail-id___zu",
    path: "/zu/news/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/news/detail/[id].vue")
  },
  {
    name: "products-charger___zh-Hans",
    path: "/zh-Hans/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___en",
    path: "/en/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___fr",
    path: "/fr/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ko",
    path: "/ko/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___th",
    path: "/th/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___zh-Hant",
    path: "/zh-Hant/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___af",
    path: "/af/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___am",
    path: "/am/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ar",
    path: "/ar/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___as",
    path: "/as/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___az",
    path: "/az/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ba",
    path: "/ba/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___be",
    path: "/be/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___bg",
    path: "/bg/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___bho",
    path: "/bho/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___bn",
    path: "/bn/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___bo",
    path: "/bo/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___brx",
    path: "/brx/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___bs",
    path: "/bs/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ca",
    path: "/ca/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___cs",
    path: "/cs/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___cy",
    path: "/cy/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___da",
    path: "/da/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___de",
    path: "/de/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___doi",
    path: "/doi/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___dsb",
    path: "/dsb/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___dv",
    path: "/dv/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___el",
    path: "/el/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___es",
    path: "/es/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___et",
    path: "/et/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___eu",
    path: "/eu/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___fa",
    path: "/fa/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___fi",
    path: "/fi/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___fil",
    path: "/fil/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___fj",
    path: "/fj/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___fo",
    path: "/fo/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___fr-CA",
    path: "/fr-CA/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ga",
    path: "/ga/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___gl",
    path: "/gl/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___gom",
    path: "/gom/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___gu",
    path: "/gu/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ha",
    path: "/ha/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___he",
    path: "/he/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___hi",
    path: "/hi/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___hne",
    path: "/hne/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___hr",
    path: "/hr/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___hsb",
    path: "/hsb/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ht",
    path: "/ht/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___hu",
    path: "/hu/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___hy",
    path: "/hy/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___id",
    path: "/id/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ig",
    path: "/ig/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ikt",
    path: "/ikt/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___is",
    path: "/is/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___it",
    path: "/it/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___iu",
    path: "/iu/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___iu-Latn",
    path: "/iu-Latn/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ja",
    path: "/ja/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ka",
    path: "/ka/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___kk",
    path: "/kk/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___km",
    path: "/km/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___kmr",
    path: "/kmr/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___kn",
    path: "/kn/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ks",
    path: "/ks/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ku",
    path: "/ku/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ky",
    path: "/ky/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___lb",
    path: "/lb/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ln",
    path: "/ln/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___lo",
    path: "/lo/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___lt",
    path: "/lt/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___lug",
    path: "/lug/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___lv",
    path: "/lv/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___lzh",
    path: "/lzh/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mai",
    path: "/mai/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mg",
    path: "/mg/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mi",
    path: "/mi/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mk",
    path: "/mk/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ml",
    path: "/ml/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mn-Cyrl",
    path: "/mn-Cyrl/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mn-Mong",
    path: "/mn-Mong/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mni",
    path: "/mni/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mr",
    path: "/mr/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ms",
    path: "/ms/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mt",
    path: "/mt/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___mww",
    path: "/mww/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___my",
    path: "/my/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___nb",
    path: "/nb/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ne",
    path: "/ne/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___nl",
    path: "/nl/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___nso",
    path: "/nso/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___nya",
    path: "/nya/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___or",
    path: "/or/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___otq",
    path: "/otq/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___pa",
    path: "/pa/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___pl",
    path: "/pl/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___prs",
    path: "/prs/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ps",
    path: "/ps/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___pt",
    path: "/pt/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___pt-PT",
    path: "/pt-PT/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ro",
    path: "/ro/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ru",
    path: "/ru/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___run",
    path: "/run/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___rw",
    path: "/rw/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sd",
    path: "/sd/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___si",
    path: "/si/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sk",
    path: "/sk/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sl",
    path: "/sl/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sm",
    path: "/sm/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sn",
    path: "/sn/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___so",
    path: "/so/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sq",
    path: "/sq/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sr-Cyrl",
    path: "/sr-Cyrl/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sr-Latn",
    path: "/sr-Latn/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___st",
    path: "/st/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sv",
    path: "/sv/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___sw",
    path: "/sw/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ta",
    path: "/ta/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___te",
    path: "/te/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ti",
    path: "/ti/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___tk",
    path: "/tk/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___tlh-Latn",
    path: "/tlh-Latn/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___tlh-Piqd",
    path: "/tlh-Piqd/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___tn",
    path: "/tn/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___to",
    path: "/to/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___tr",
    path: "/tr/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___tt",
    path: "/tt/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ty",
    path: "/ty/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ug",
    path: "/ug/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___uk",
    path: "/uk/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___ur",
    path: "/ur/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___uz",
    path: "/uz/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___vi",
    path: "/vi/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___xh",
    path: "/xh/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___yo",
    path: "/yo/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___yua",
    path: "/yua/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___yue",
    path: "/yue/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "products-charger___zu",
    path: "/zu/products/charger",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charger.vue")
  },
  {
    name: "solutions-detail___zh-Hans",
    path: "/zh-Hans/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___en",
    path: "/en/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___fr",
    path: "/fr/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ko",
    path: "/ko/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___th",
    path: "/th/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___zh-Hant",
    path: "/zh-Hant/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___af",
    path: "/af/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___am",
    path: "/am/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ar",
    path: "/ar/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___as",
    path: "/as/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___az",
    path: "/az/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ba",
    path: "/ba/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___be",
    path: "/be/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___bg",
    path: "/bg/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___bho",
    path: "/bho/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___bn",
    path: "/bn/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___bo",
    path: "/bo/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___brx",
    path: "/brx/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___bs",
    path: "/bs/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ca",
    path: "/ca/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___cs",
    path: "/cs/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___cy",
    path: "/cy/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___da",
    path: "/da/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___de",
    path: "/de/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___doi",
    path: "/doi/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___dsb",
    path: "/dsb/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___dv",
    path: "/dv/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___el",
    path: "/el/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___es",
    path: "/es/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___et",
    path: "/et/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___eu",
    path: "/eu/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___fa",
    path: "/fa/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___fi",
    path: "/fi/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___fil",
    path: "/fil/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___fj",
    path: "/fj/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___fo",
    path: "/fo/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___fr-CA",
    path: "/fr-CA/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ga",
    path: "/ga/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___gl",
    path: "/gl/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___gom",
    path: "/gom/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___gu",
    path: "/gu/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ha",
    path: "/ha/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___he",
    path: "/he/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___hi",
    path: "/hi/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___hne",
    path: "/hne/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___hr",
    path: "/hr/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___hsb",
    path: "/hsb/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ht",
    path: "/ht/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___hu",
    path: "/hu/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___hy",
    path: "/hy/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___id",
    path: "/id/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ig",
    path: "/ig/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ikt",
    path: "/ikt/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___is",
    path: "/is/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___it",
    path: "/it/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___iu",
    path: "/iu/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___iu-Latn",
    path: "/iu-Latn/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ja",
    path: "/ja/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ka",
    path: "/ka/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___kk",
    path: "/kk/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___km",
    path: "/km/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___kmr",
    path: "/kmr/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___kn",
    path: "/kn/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ks",
    path: "/ks/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ku",
    path: "/ku/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ky",
    path: "/ky/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___lb",
    path: "/lb/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ln",
    path: "/ln/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___lo",
    path: "/lo/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___lt",
    path: "/lt/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___lug",
    path: "/lug/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___lv",
    path: "/lv/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___lzh",
    path: "/lzh/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mai",
    path: "/mai/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mg",
    path: "/mg/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mi",
    path: "/mi/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mk",
    path: "/mk/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ml",
    path: "/ml/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mn-Cyrl",
    path: "/mn-Cyrl/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mn-Mong",
    path: "/mn-Mong/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mni",
    path: "/mni/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mr",
    path: "/mr/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ms",
    path: "/ms/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mt",
    path: "/mt/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___mww",
    path: "/mww/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___my",
    path: "/my/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___nb",
    path: "/nb/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ne",
    path: "/ne/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___nl",
    path: "/nl/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___nso",
    path: "/nso/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___nya",
    path: "/nya/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___or",
    path: "/or/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___otq",
    path: "/otq/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___pa",
    path: "/pa/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___pl",
    path: "/pl/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___prs",
    path: "/prs/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ps",
    path: "/ps/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___pt",
    path: "/pt/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___pt-PT",
    path: "/pt-PT/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ro",
    path: "/ro/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ru",
    path: "/ru/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___run",
    path: "/run/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___rw",
    path: "/rw/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sd",
    path: "/sd/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___si",
    path: "/si/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sk",
    path: "/sk/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sl",
    path: "/sl/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sm",
    path: "/sm/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sn",
    path: "/sn/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___so",
    path: "/so/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sq",
    path: "/sq/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sr-Cyrl",
    path: "/sr-Cyrl/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sr-Latn",
    path: "/sr-Latn/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___st",
    path: "/st/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sv",
    path: "/sv/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___sw",
    path: "/sw/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ta",
    path: "/ta/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___te",
    path: "/te/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ti",
    path: "/ti/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___tk",
    path: "/tk/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___tlh-Latn",
    path: "/tlh-Latn/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___tlh-Piqd",
    path: "/tlh-Piqd/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___tn",
    path: "/tn/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___to",
    path: "/to/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___tr",
    path: "/tr/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___tt",
    path: "/tt/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ty",
    path: "/ty/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ug",
    path: "/ug/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___uk",
    path: "/uk/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___ur",
    path: "/ur/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___uz",
    path: "/uz/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___vi",
    path: "/vi/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___xh",
    path: "/xh/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___yo",
    path: "/yo/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___yua",
    path: "/yua/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___yue",
    path: "/yue/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "solutions-detail___zu",
    path: "/zu/solutions/detail",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/detail.vue")
  },
  {
    name: "products-detail-id___zh-Hans",
    path: "/zh-Hans/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___en",
    path: "/en/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___fr",
    path: "/fr/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ko",
    path: "/ko/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___th",
    path: "/th/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___zh-Hant",
    path: "/zh-Hant/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___af",
    path: "/af/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___am",
    path: "/am/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ar",
    path: "/ar/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___as",
    path: "/as/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___az",
    path: "/az/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ba",
    path: "/ba/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___be",
    path: "/be/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___bg",
    path: "/bg/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___bho",
    path: "/bho/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___bn",
    path: "/bn/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___bo",
    path: "/bo/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___brx",
    path: "/brx/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___bs",
    path: "/bs/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ca",
    path: "/ca/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___cs",
    path: "/cs/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___cy",
    path: "/cy/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___da",
    path: "/da/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___de",
    path: "/de/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___doi",
    path: "/doi/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___dsb",
    path: "/dsb/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___dv",
    path: "/dv/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___el",
    path: "/el/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___es",
    path: "/es/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___et",
    path: "/et/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___eu",
    path: "/eu/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___fa",
    path: "/fa/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___fi",
    path: "/fi/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___fil",
    path: "/fil/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___fj",
    path: "/fj/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___fo",
    path: "/fo/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___fr-CA",
    path: "/fr-CA/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ga",
    path: "/ga/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___gl",
    path: "/gl/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___gom",
    path: "/gom/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___gu",
    path: "/gu/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ha",
    path: "/ha/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___he",
    path: "/he/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___hi",
    path: "/hi/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___hne",
    path: "/hne/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___hr",
    path: "/hr/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___hsb",
    path: "/hsb/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ht",
    path: "/ht/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___hu",
    path: "/hu/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___hy",
    path: "/hy/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___id",
    path: "/id/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ig",
    path: "/ig/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ikt",
    path: "/ikt/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___is",
    path: "/is/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___it",
    path: "/it/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___iu",
    path: "/iu/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___iu-Latn",
    path: "/iu-Latn/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ja",
    path: "/ja/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ka",
    path: "/ka/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___kk",
    path: "/kk/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___km",
    path: "/km/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___kmr",
    path: "/kmr/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___kn",
    path: "/kn/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ks",
    path: "/ks/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ku",
    path: "/ku/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ky",
    path: "/ky/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___lb",
    path: "/lb/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ln",
    path: "/ln/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___lo",
    path: "/lo/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___lt",
    path: "/lt/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___lug",
    path: "/lug/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___lv",
    path: "/lv/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___lzh",
    path: "/lzh/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mai",
    path: "/mai/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mg",
    path: "/mg/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mi",
    path: "/mi/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mk",
    path: "/mk/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ml",
    path: "/ml/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mn-Cyrl",
    path: "/mn-Cyrl/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mn-Mong",
    path: "/mn-Mong/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mni",
    path: "/mni/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mr",
    path: "/mr/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ms",
    path: "/ms/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mt",
    path: "/mt/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___mww",
    path: "/mww/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___my",
    path: "/my/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___nb",
    path: "/nb/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ne",
    path: "/ne/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___nl",
    path: "/nl/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___nso",
    path: "/nso/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___nya",
    path: "/nya/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___or",
    path: "/or/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___otq",
    path: "/otq/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___pa",
    path: "/pa/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___pl",
    path: "/pl/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___prs",
    path: "/prs/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ps",
    path: "/ps/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___pt",
    path: "/pt/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___pt-PT",
    path: "/pt-PT/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ro",
    path: "/ro/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ru",
    path: "/ru/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___run",
    path: "/run/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___rw",
    path: "/rw/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sd",
    path: "/sd/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___si",
    path: "/si/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sk",
    path: "/sk/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sl",
    path: "/sl/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sm",
    path: "/sm/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sn",
    path: "/sn/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___so",
    path: "/so/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sq",
    path: "/sq/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sr-Cyrl",
    path: "/sr-Cyrl/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sr-Latn",
    path: "/sr-Latn/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___st",
    path: "/st/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sv",
    path: "/sv/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___sw",
    path: "/sw/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ta",
    path: "/ta/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___te",
    path: "/te/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ti",
    path: "/ti/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___tk",
    path: "/tk/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___tlh-Latn",
    path: "/tlh-Latn/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___tlh-Piqd",
    path: "/tlh-Piqd/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___tn",
    path: "/tn/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___to",
    path: "/to/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___tr",
    path: "/tr/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___tt",
    path: "/tt/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ty",
    path: "/ty/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ug",
    path: "/ug/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___uk",
    path: "/uk/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___ur",
    path: "/ur/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___uz",
    path: "/uz/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___vi",
    path: "/vi/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___xh",
    path: "/xh/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___yo",
    path: "/yo/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___yua",
    path: "/yua/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___yue",
    path: "/yue/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-detail-id___zu",
    path: "/zu/products/detail/:id()",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/detail/[id].vue")
  },
  {
    name: "products-battery-swap___zh-Hans",
    path: "/zh-Hans/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___en",
    path: "/en/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___fr",
    path: "/fr/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ko",
    path: "/ko/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___th",
    path: "/th/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___zh-Hant",
    path: "/zh-Hant/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___af",
    path: "/af/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___am",
    path: "/am/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ar",
    path: "/ar/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___as",
    path: "/as/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___az",
    path: "/az/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ba",
    path: "/ba/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___be",
    path: "/be/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___bg",
    path: "/bg/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___bho",
    path: "/bho/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___bn",
    path: "/bn/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___bo",
    path: "/bo/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___brx",
    path: "/brx/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___bs",
    path: "/bs/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ca",
    path: "/ca/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___cs",
    path: "/cs/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___cy",
    path: "/cy/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___da",
    path: "/da/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___de",
    path: "/de/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___doi",
    path: "/doi/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___dsb",
    path: "/dsb/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___dv",
    path: "/dv/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___el",
    path: "/el/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___es",
    path: "/es/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___et",
    path: "/et/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___eu",
    path: "/eu/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___fa",
    path: "/fa/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___fi",
    path: "/fi/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___fil",
    path: "/fil/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___fj",
    path: "/fj/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___fo",
    path: "/fo/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___fr-CA",
    path: "/fr-CA/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ga",
    path: "/ga/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___gl",
    path: "/gl/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___gom",
    path: "/gom/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___gu",
    path: "/gu/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ha",
    path: "/ha/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___he",
    path: "/he/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___hi",
    path: "/hi/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___hne",
    path: "/hne/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___hr",
    path: "/hr/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___hsb",
    path: "/hsb/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ht",
    path: "/ht/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___hu",
    path: "/hu/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___hy",
    path: "/hy/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___id",
    path: "/id/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ig",
    path: "/ig/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ikt",
    path: "/ikt/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___is",
    path: "/is/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___it",
    path: "/it/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___iu",
    path: "/iu/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___iu-Latn",
    path: "/iu-Latn/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ja",
    path: "/ja/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ka",
    path: "/ka/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___kk",
    path: "/kk/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___km",
    path: "/km/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___kmr",
    path: "/kmr/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___kn",
    path: "/kn/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ks",
    path: "/ks/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ku",
    path: "/ku/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ky",
    path: "/ky/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___lb",
    path: "/lb/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ln",
    path: "/ln/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___lo",
    path: "/lo/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___lt",
    path: "/lt/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___lug",
    path: "/lug/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___lv",
    path: "/lv/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___lzh",
    path: "/lzh/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mai",
    path: "/mai/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mg",
    path: "/mg/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mi",
    path: "/mi/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mk",
    path: "/mk/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ml",
    path: "/ml/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mn-Cyrl",
    path: "/mn-Cyrl/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mn-Mong",
    path: "/mn-Mong/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mni",
    path: "/mni/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mr",
    path: "/mr/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ms",
    path: "/ms/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mt",
    path: "/mt/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___mww",
    path: "/mww/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___my",
    path: "/my/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___nb",
    path: "/nb/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ne",
    path: "/ne/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___nl",
    path: "/nl/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___nso",
    path: "/nso/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___nya",
    path: "/nya/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___or",
    path: "/or/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___otq",
    path: "/otq/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___pa",
    path: "/pa/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___pl",
    path: "/pl/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___prs",
    path: "/prs/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ps",
    path: "/ps/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___pt",
    path: "/pt/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___pt-PT",
    path: "/pt-PT/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ro",
    path: "/ro/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ru",
    path: "/ru/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___run",
    path: "/run/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___rw",
    path: "/rw/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sd",
    path: "/sd/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___si",
    path: "/si/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sk",
    path: "/sk/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sl",
    path: "/sl/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sm",
    path: "/sm/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sn",
    path: "/sn/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___so",
    path: "/so/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sq",
    path: "/sq/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sr-Cyrl",
    path: "/sr-Cyrl/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sr-Latn",
    path: "/sr-Latn/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___st",
    path: "/st/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sv",
    path: "/sv/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___sw",
    path: "/sw/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ta",
    path: "/ta/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___te",
    path: "/te/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ti",
    path: "/ti/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___tk",
    path: "/tk/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___tlh-Latn",
    path: "/tlh-Latn/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___tlh-Piqd",
    path: "/tlh-Piqd/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___tn",
    path: "/tn/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___to",
    path: "/to/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___tr",
    path: "/tr/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___tt",
    path: "/tt/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ty",
    path: "/ty/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ug",
    path: "/ug/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___uk",
    path: "/uk/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___ur",
    path: "/ur/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___uz",
    path: "/uz/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___vi",
    path: "/vi/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___xh",
    path: "/xh/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___yo",
    path: "/yo/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___yua",
    path: "/yua/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___yue",
    path: "/yue/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "products-battery-swap___zu",
    path: "/zu/products/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___zh-Hans",
    path: "/zh-Hans/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___en",
    path: "/en/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___fr",
    path: "/fr/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ko",
    path: "/ko/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___th",
    path: "/th/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___zh-Hant",
    path: "/zh-Hant/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___af",
    path: "/af/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___am",
    path: "/am/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ar",
    path: "/ar/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___as",
    path: "/as/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___az",
    path: "/az/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ba",
    path: "/ba/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___be",
    path: "/be/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___bg",
    path: "/bg/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___bho",
    path: "/bho/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___bn",
    path: "/bn/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___bo",
    path: "/bo/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___brx",
    path: "/brx/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___bs",
    path: "/bs/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ca",
    path: "/ca/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___cs",
    path: "/cs/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___cy",
    path: "/cy/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___da",
    path: "/da/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___de",
    path: "/de/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___doi",
    path: "/doi/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___dsb",
    path: "/dsb/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___dv",
    path: "/dv/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___el",
    path: "/el/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___es",
    path: "/es/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___et",
    path: "/et/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___eu",
    path: "/eu/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___fa",
    path: "/fa/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___fi",
    path: "/fi/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___fil",
    path: "/fil/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___fj",
    path: "/fj/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___fo",
    path: "/fo/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___fr-CA",
    path: "/fr-CA/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ga",
    path: "/ga/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___gl",
    path: "/gl/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___gom",
    path: "/gom/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___gu",
    path: "/gu/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ha",
    path: "/ha/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___he",
    path: "/he/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___hi",
    path: "/hi/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___hne",
    path: "/hne/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___hr",
    path: "/hr/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___hsb",
    path: "/hsb/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ht",
    path: "/ht/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___hu",
    path: "/hu/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___hy",
    path: "/hy/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___id",
    path: "/id/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ig",
    path: "/ig/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ikt",
    path: "/ikt/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___is",
    path: "/is/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___it",
    path: "/it/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___iu",
    path: "/iu/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___iu-Latn",
    path: "/iu-Latn/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ja",
    path: "/ja/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ka",
    path: "/ka/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___kk",
    path: "/kk/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___km",
    path: "/km/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___kmr",
    path: "/kmr/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___kn",
    path: "/kn/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ks",
    path: "/ks/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ku",
    path: "/ku/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ky",
    path: "/ky/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___lb",
    path: "/lb/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ln",
    path: "/ln/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___lo",
    path: "/lo/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___lt",
    path: "/lt/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___lug",
    path: "/lug/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___lv",
    path: "/lv/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___lzh",
    path: "/lzh/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mai",
    path: "/mai/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mg",
    path: "/mg/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mi",
    path: "/mi/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mk",
    path: "/mk/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ml",
    path: "/ml/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mn-Cyrl",
    path: "/mn-Cyrl/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mn-Mong",
    path: "/mn-Mong/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mni",
    path: "/mni/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mr",
    path: "/mr/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ms",
    path: "/ms/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mt",
    path: "/mt/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___mww",
    path: "/mww/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___my",
    path: "/my/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___nb",
    path: "/nb/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ne",
    path: "/ne/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___nl",
    path: "/nl/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___nso",
    path: "/nso/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___nya",
    path: "/nya/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___or",
    path: "/or/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___otq",
    path: "/otq/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___pa",
    path: "/pa/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___pl",
    path: "/pl/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___prs",
    path: "/prs/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ps",
    path: "/ps/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___pt",
    path: "/pt/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___pt-PT",
    path: "/pt-PT/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ro",
    path: "/ro/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ru",
    path: "/ru/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___run",
    path: "/run/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___rw",
    path: "/rw/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sd",
    path: "/sd/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___si",
    path: "/si/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sk",
    path: "/sk/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sl",
    path: "/sl/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sm",
    path: "/sm/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sn",
    path: "/sn/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___so",
    path: "/so/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sq",
    path: "/sq/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sr-Cyrl",
    path: "/sr-Cyrl/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sr-Latn",
    path: "/sr-Latn/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___st",
    path: "/st/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sv",
    path: "/sv/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___sw",
    path: "/sw/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ta",
    path: "/ta/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___te",
    path: "/te/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ti",
    path: "/ti/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___tk",
    path: "/tk/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___tlh-Latn",
    path: "/tlh-Latn/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___tlh-Piqd",
    path: "/tlh-Piqd/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___tn",
    path: "/tn/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___to",
    path: "/to/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___tr",
    path: "/tr/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___tt",
    path: "/tt/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ty",
    path: "/ty/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ug",
    path: "/ug/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___uk",
    path: "/uk/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___ur",
    path: "/ur/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___uz",
    path: "/uz/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___vi",
    path: "/vi/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___xh",
    path: "/xh/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___yo",
    path: "/yo/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___yua",
    path: "/yua/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___yue",
    path: "/yue/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "solutions-battery-swap___zu",
    path: "/zu/solutions/battery-swap",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/battery-swap.vue")
  },
  {
    name: "products-storage-cabinet___zh-Hans",
    path: "/zh-Hans/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___en",
    path: "/en/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___fr",
    path: "/fr/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ko",
    path: "/ko/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___th",
    path: "/th/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___zh-Hant",
    path: "/zh-Hant/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___af",
    path: "/af/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___am",
    path: "/am/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ar",
    path: "/ar/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___as",
    path: "/as/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___az",
    path: "/az/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ba",
    path: "/ba/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___be",
    path: "/be/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___bg",
    path: "/bg/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___bho",
    path: "/bho/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___bn",
    path: "/bn/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___bo",
    path: "/bo/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___brx",
    path: "/brx/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___bs",
    path: "/bs/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ca",
    path: "/ca/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___cs",
    path: "/cs/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___cy",
    path: "/cy/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___da",
    path: "/da/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___de",
    path: "/de/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___doi",
    path: "/doi/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___dsb",
    path: "/dsb/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___dv",
    path: "/dv/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___el",
    path: "/el/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___es",
    path: "/es/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___et",
    path: "/et/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___eu",
    path: "/eu/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___fa",
    path: "/fa/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___fi",
    path: "/fi/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___fil",
    path: "/fil/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___fj",
    path: "/fj/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___fo",
    path: "/fo/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___fr-CA",
    path: "/fr-CA/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ga",
    path: "/ga/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___gl",
    path: "/gl/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___gom",
    path: "/gom/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___gu",
    path: "/gu/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ha",
    path: "/ha/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___he",
    path: "/he/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___hi",
    path: "/hi/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___hne",
    path: "/hne/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___hr",
    path: "/hr/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___hsb",
    path: "/hsb/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ht",
    path: "/ht/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___hu",
    path: "/hu/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___hy",
    path: "/hy/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___id",
    path: "/id/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ig",
    path: "/ig/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ikt",
    path: "/ikt/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___is",
    path: "/is/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___it",
    path: "/it/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___iu",
    path: "/iu/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___iu-Latn",
    path: "/iu-Latn/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ja",
    path: "/ja/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ka",
    path: "/ka/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___kk",
    path: "/kk/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___km",
    path: "/km/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___kmr",
    path: "/kmr/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___kn",
    path: "/kn/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ks",
    path: "/ks/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ku",
    path: "/ku/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ky",
    path: "/ky/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___lb",
    path: "/lb/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ln",
    path: "/ln/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___lo",
    path: "/lo/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___lt",
    path: "/lt/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___lug",
    path: "/lug/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___lv",
    path: "/lv/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___lzh",
    path: "/lzh/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mai",
    path: "/mai/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mg",
    path: "/mg/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mi",
    path: "/mi/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mk",
    path: "/mk/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ml",
    path: "/ml/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mn-Cyrl",
    path: "/mn-Cyrl/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mn-Mong",
    path: "/mn-Mong/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mni",
    path: "/mni/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mr",
    path: "/mr/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ms",
    path: "/ms/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mt",
    path: "/mt/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___mww",
    path: "/mww/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___my",
    path: "/my/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___nb",
    path: "/nb/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ne",
    path: "/ne/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___nl",
    path: "/nl/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___nso",
    path: "/nso/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___nya",
    path: "/nya/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___or",
    path: "/or/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___otq",
    path: "/otq/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___pa",
    path: "/pa/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___pl",
    path: "/pl/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___prs",
    path: "/prs/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ps",
    path: "/ps/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___pt",
    path: "/pt/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___pt-PT",
    path: "/pt-PT/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ro",
    path: "/ro/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ru",
    path: "/ru/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___run",
    path: "/run/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___rw",
    path: "/rw/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sd",
    path: "/sd/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___si",
    path: "/si/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sk",
    path: "/sk/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sl",
    path: "/sl/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sm",
    path: "/sm/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sn",
    path: "/sn/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___so",
    path: "/so/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sq",
    path: "/sq/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sr-Cyrl",
    path: "/sr-Cyrl/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sr-Latn",
    path: "/sr-Latn/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___st",
    path: "/st/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sv",
    path: "/sv/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___sw",
    path: "/sw/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ta",
    path: "/ta/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___te",
    path: "/te/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ti",
    path: "/ti/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___tk",
    path: "/tk/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___tlh-Latn",
    path: "/tlh-Latn/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___tlh-Piqd",
    path: "/tlh-Piqd/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___tn",
    path: "/tn/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___to",
    path: "/to/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___tr",
    path: "/tr/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___tt",
    path: "/tt/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ty",
    path: "/ty/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ug",
    path: "/ug/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___uk",
    path: "/uk/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___ur",
    path: "/ur/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___uz",
    path: "/uz/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___vi",
    path: "/vi/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___xh",
    path: "/xh/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___yo",
    path: "/yo/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___yua",
    path: "/yua/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___yue",
    path: "/yue/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-storage-cabinet___zu",
    path: "/zu/products/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/storage-cabinet.vue")
  },
  {
    name: "products-charging-station___zh-Hans",
    path: "/zh-Hans/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___en",
    path: "/en/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___fr",
    path: "/fr/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ko",
    path: "/ko/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___th",
    path: "/th/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___zh-Hant",
    path: "/zh-Hant/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___af",
    path: "/af/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___am",
    path: "/am/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ar",
    path: "/ar/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___as",
    path: "/as/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___az",
    path: "/az/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ba",
    path: "/ba/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___be",
    path: "/be/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___bg",
    path: "/bg/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___bho",
    path: "/bho/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___bn",
    path: "/bn/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___bo",
    path: "/bo/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___brx",
    path: "/brx/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___bs",
    path: "/bs/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ca",
    path: "/ca/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___cs",
    path: "/cs/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___cy",
    path: "/cy/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___da",
    path: "/da/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___de",
    path: "/de/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___doi",
    path: "/doi/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___dsb",
    path: "/dsb/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___dv",
    path: "/dv/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___el",
    path: "/el/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___es",
    path: "/es/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___et",
    path: "/et/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___eu",
    path: "/eu/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___fa",
    path: "/fa/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___fi",
    path: "/fi/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___fil",
    path: "/fil/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___fj",
    path: "/fj/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___fo",
    path: "/fo/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___fr-CA",
    path: "/fr-CA/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ga",
    path: "/ga/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___gl",
    path: "/gl/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___gom",
    path: "/gom/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___gu",
    path: "/gu/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ha",
    path: "/ha/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___he",
    path: "/he/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___hi",
    path: "/hi/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___hne",
    path: "/hne/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___hr",
    path: "/hr/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___hsb",
    path: "/hsb/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ht",
    path: "/ht/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___hu",
    path: "/hu/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___hy",
    path: "/hy/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___id",
    path: "/id/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ig",
    path: "/ig/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ikt",
    path: "/ikt/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___is",
    path: "/is/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___it",
    path: "/it/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___iu",
    path: "/iu/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___iu-Latn",
    path: "/iu-Latn/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ja",
    path: "/ja/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ka",
    path: "/ka/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___kk",
    path: "/kk/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___km",
    path: "/km/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___kmr",
    path: "/kmr/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___kn",
    path: "/kn/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ks",
    path: "/ks/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ku",
    path: "/ku/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ky",
    path: "/ky/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___lb",
    path: "/lb/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ln",
    path: "/ln/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___lo",
    path: "/lo/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___lt",
    path: "/lt/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___lug",
    path: "/lug/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___lv",
    path: "/lv/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___lzh",
    path: "/lzh/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mai",
    path: "/mai/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mg",
    path: "/mg/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mi",
    path: "/mi/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mk",
    path: "/mk/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ml",
    path: "/ml/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mn-Cyrl",
    path: "/mn-Cyrl/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mn-Mong",
    path: "/mn-Mong/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mni",
    path: "/mni/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mr",
    path: "/mr/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ms",
    path: "/ms/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mt",
    path: "/mt/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___mww",
    path: "/mww/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___my",
    path: "/my/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___nb",
    path: "/nb/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ne",
    path: "/ne/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___nl",
    path: "/nl/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___nso",
    path: "/nso/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___nya",
    path: "/nya/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___or",
    path: "/or/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___otq",
    path: "/otq/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___pa",
    path: "/pa/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___pl",
    path: "/pl/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___prs",
    path: "/prs/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ps",
    path: "/ps/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___pt",
    path: "/pt/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___pt-PT",
    path: "/pt-PT/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ro",
    path: "/ro/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ru",
    path: "/ru/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___run",
    path: "/run/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___rw",
    path: "/rw/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sd",
    path: "/sd/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___si",
    path: "/si/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sk",
    path: "/sk/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sl",
    path: "/sl/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sm",
    path: "/sm/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sn",
    path: "/sn/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___so",
    path: "/so/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sq",
    path: "/sq/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sr-Cyrl",
    path: "/sr-Cyrl/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sr-Latn",
    path: "/sr-Latn/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___st",
    path: "/st/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sv",
    path: "/sv/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___sw",
    path: "/sw/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ta",
    path: "/ta/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___te",
    path: "/te/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ti",
    path: "/ti/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___tk",
    path: "/tk/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___tlh-Latn",
    path: "/tlh-Latn/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___tlh-Piqd",
    path: "/tlh-Piqd/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___tn",
    path: "/tn/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___to",
    path: "/to/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___tr",
    path: "/tr/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___tt",
    path: "/tt/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ty",
    path: "/ty/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ug",
    path: "/ug/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___uk",
    path: "/uk/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___ur",
    path: "/ur/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___uz",
    path: "/uz/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___vi",
    path: "/vi/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___xh",
    path: "/xh/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___yo",
    path: "/yo/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___yua",
    path: "/yua/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___yue",
    path: "/yue/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "products-charging-station___zu",
    path: "/zu/products/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/products/charging-station.vue")
  },
  {
    name: "solutions-storage-cabinet___zh-Hans",
    path: "/zh-Hans/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___en",
    path: "/en/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___fr",
    path: "/fr/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ko",
    path: "/ko/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___th",
    path: "/th/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___zh-Hant",
    path: "/zh-Hant/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___af",
    path: "/af/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___am",
    path: "/am/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ar",
    path: "/ar/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___as",
    path: "/as/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___az",
    path: "/az/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ba",
    path: "/ba/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___be",
    path: "/be/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___bg",
    path: "/bg/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___bho",
    path: "/bho/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___bn",
    path: "/bn/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___bo",
    path: "/bo/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___brx",
    path: "/brx/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___bs",
    path: "/bs/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ca",
    path: "/ca/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___cs",
    path: "/cs/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___cy",
    path: "/cy/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___da",
    path: "/da/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___de",
    path: "/de/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___doi",
    path: "/doi/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___dsb",
    path: "/dsb/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___dv",
    path: "/dv/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___el",
    path: "/el/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___es",
    path: "/es/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___et",
    path: "/et/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___eu",
    path: "/eu/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___fa",
    path: "/fa/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___fi",
    path: "/fi/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___fil",
    path: "/fil/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___fj",
    path: "/fj/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___fo",
    path: "/fo/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___fr-CA",
    path: "/fr-CA/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ga",
    path: "/ga/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___gl",
    path: "/gl/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___gom",
    path: "/gom/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___gu",
    path: "/gu/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ha",
    path: "/ha/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___he",
    path: "/he/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___hi",
    path: "/hi/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___hne",
    path: "/hne/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___hr",
    path: "/hr/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___hsb",
    path: "/hsb/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ht",
    path: "/ht/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___hu",
    path: "/hu/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___hy",
    path: "/hy/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___id",
    path: "/id/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ig",
    path: "/ig/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ikt",
    path: "/ikt/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___is",
    path: "/is/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___it",
    path: "/it/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___iu",
    path: "/iu/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___iu-Latn",
    path: "/iu-Latn/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ja",
    path: "/ja/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ka",
    path: "/ka/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___kk",
    path: "/kk/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___km",
    path: "/km/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___kmr",
    path: "/kmr/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___kn",
    path: "/kn/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ks",
    path: "/ks/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ku",
    path: "/ku/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ky",
    path: "/ky/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___lb",
    path: "/lb/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ln",
    path: "/ln/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___lo",
    path: "/lo/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___lt",
    path: "/lt/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___lug",
    path: "/lug/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___lv",
    path: "/lv/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___lzh",
    path: "/lzh/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mai",
    path: "/mai/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mg",
    path: "/mg/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mi",
    path: "/mi/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mk",
    path: "/mk/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ml",
    path: "/ml/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mn-Cyrl",
    path: "/mn-Cyrl/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mn-Mong",
    path: "/mn-Mong/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mni",
    path: "/mni/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mr",
    path: "/mr/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ms",
    path: "/ms/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mt",
    path: "/mt/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___mww",
    path: "/mww/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___my",
    path: "/my/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___nb",
    path: "/nb/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ne",
    path: "/ne/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___nl",
    path: "/nl/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___nso",
    path: "/nso/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___nya",
    path: "/nya/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___or",
    path: "/or/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___otq",
    path: "/otq/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___pa",
    path: "/pa/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___pl",
    path: "/pl/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___prs",
    path: "/prs/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ps",
    path: "/ps/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___pt",
    path: "/pt/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___pt-PT",
    path: "/pt-PT/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ro",
    path: "/ro/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ru",
    path: "/ru/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___run",
    path: "/run/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___rw",
    path: "/rw/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sd",
    path: "/sd/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___si",
    path: "/si/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sk",
    path: "/sk/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sl",
    path: "/sl/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sm",
    path: "/sm/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sn",
    path: "/sn/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___so",
    path: "/so/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sq",
    path: "/sq/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sr-Cyrl",
    path: "/sr-Cyrl/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sr-Latn",
    path: "/sr-Latn/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___st",
    path: "/st/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sv",
    path: "/sv/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___sw",
    path: "/sw/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ta",
    path: "/ta/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___te",
    path: "/te/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ti",
    path: "/ti/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___tk",
    path: "/tk/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___tlh-Latn",
    path: "/tlh-Latn/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___tlh-Piqd",
    path: "/tlh-Piqd/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___tn",
    path: "/tn/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___to",
    path: "/to/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___tr",
    path: "/tr/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___tt",
    path: "/tt/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ty",
    path: "/ty/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ug",
    path: "/ug/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___uk",
    path: "/uk/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___ur",
    path: "/ur/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___uz",
    path: "/uz/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___vi",
    path: "/vi/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___xh",
    path: "/xh/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___yo",
    path: "/yo/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___yua",
    path: "/yua/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___yue",
    path: "/yue/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-storage-cabinet___zu",
    path: "/zu/solutions/storage-cabinet",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/storage-cabinet.vue")
  },
  {
    name: "solutions-charging-station___zh-Hans",
    path: "/zh-Hans/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___en",
    path: "/en/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___fr",
    path: "/fr/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ko",
    path: "/ko/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___th",
    path: "/th/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___zh-Hant",
    path: "/zh-Hant/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___af",
    path: "/af/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___am",
    path: "/am/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ar",
    path: "/ar/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___as",
    path: "/as/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___az",
    path: "/az/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ba",
    path: "/ba/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___be",
    path: "/be/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___bg",
    path: "/bg/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___bho",
    path: "/bho/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___bn",
    path: "/bn/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___bo",
    path: "/bo/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___brx",
    path: "/brx/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___bs",
    path: "/bs/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ca",
    path: "/ca/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___cs",
    path: "/cs/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___cy",
    path: "/cy/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___da",
    path: "/da/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___de",
    path: "/de/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___doi",
    path: "/doi/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___dsb",
    path: "/dsb/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___dv",
    path: "/dv/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___el",
    path: "/el/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___es",
    path: "/es/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___et",
    path: "/et/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___eu",
    path: "/eu/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___fa",
    path: "/fa/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___fi",
    path: "/fi/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___fil",
    path: "/fil/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___fj",
    path: "/fj/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___fo",
    path: "/fo/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___fr-CA",
    path: "/fr-CA/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ga",
    path: "/ga/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___gl",
    path: "/gl/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___gom",
    path: "/gom/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___gu",
    path: "/gu/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ha",
    path: "/ha/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___he",
    path: "/he/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___hi",
    path: "/hi/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___hne",
    path: "/hne/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___hr",
    path: "/hr/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___hsb",
    path: "/hsb/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ht",
    path: "/ht/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___hu",
    path: "/hu/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___hy",
    path: "/hy/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___id",
    path: "/id/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ig",
    path: "/ig/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ikt",
    path: "/ikt/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___is",
    path: "/is/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___it",
    path: "/it/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___iu",
    path: "/iu/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___iu-Latn",
    path: "/iu-Latn/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ja",
    path: "/ja/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ka",
    path: "/ka/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___kk",
    path: "/kk/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___km",
    path: "/km/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___kmr",
    path: "/kmr/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___kn",
    path: "/kn/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ks",
    path: "/ks/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ku",
    path: "/ku/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ky",
    path: "/ky/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___lb",
    path: "/lb/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ln",
    path: "/ln/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___lo",
    path: "/lo/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___lt",
    path: "/lt/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___lug",
    path: "/lug/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___lv",
    path: "/lv/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___lzh",
    path: "/lzh/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mai",
    path: "/mai/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mg",
    path: "/mg/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mi",
    path: "/mi/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mk",
    path: "/mk/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ml",
    path: "/ml/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mn-Cyrl",
    path: "/mn-Cyrl/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mn-Mong",
    path: "/mn-Mong/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mni",
    path: "/mni/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mr",
    path: "/mr/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ms",
    path: "/ms/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mt",
    path: "/mt/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___mww",
    path: "/mww/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___my",
    path: "/my/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___nb",
    path: "/nb/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ne",
    path: "/ne/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___nl",
    path: "/nl/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___nso",
    path: "/nso/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___nya",
    path: "/nya/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___or",
    path: "/or/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___otq",
    path: "/otq/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___pa",
    path: "/pa/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___pl",
    path: "/pl/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___prs",
    path: "/prs/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ps",
    path: "/ps/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___pt",
    path: "/pt/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___pt-PT",
    path: "/pt-PT/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ro",
    path: "/ro/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ru",
    path: "/ru/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___run",
    path: "/run/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___rw",
    path: "/rw/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sd",
    path: "/sd/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___si",
    path: "/si/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sk",
    path: "/sk/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sl",
    path: "/sl/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sm",
    path: "/sm/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sn",
    path: "/sn/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___so",
    path: "/so/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sq",
    path: "/sq/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sr-Cyrl",
    path: "/sr-Cyrl/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sr-Latn",
    path: "/sr-Latn/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___st",
    path: "/st/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sv",
    path: "/sv/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___sw",
    path: "/sw/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ta",
    path: "/ta/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___te",
    path: "/te/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ti",
    path: "/ti/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___tk",
    path: "/tk/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___tlh-Latn",
    path: "/tlh-Latn/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___tlh-Piqd",
    path: "/tlh-Piqd/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___tn",
    path: "/tn/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___to",
    path: "/to/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___tr",
    path: "/tr/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___tt",
    path: "/tt/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ty",
    path: "/ty/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ug",
    path: "/ug/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___uk",
    path: "/uk/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___ur",
    path: "/ur/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___uz",
    path: "/uz/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___vi",
    path: "/vi/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___xh",
    path: "/xh/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___yo",
    path: "/yo/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___yua",
    path: "/yua/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___yue",
    path: "/yue/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  },
  {
    name: "solutions-charging-station___zu",
    path: "/zu/solutions/charging-station",
    component: () => import("/Users/xnng/code/sre/official/official_website/pages/solutions/charging-station.vue")
  }
]